<template>
    <div></div>
</template>
<script>
import {getAuthInfo,fraudCheck } from '@api/index'
import { onMounted, getCurrentInstance } from 'vue'
import {useRouter} from 'vue-router'
import { useLoading } from 'vue-loading-overlay'
import { getOrders } from '../../../api/index'
export default {
    setup () {
        const router = useRouter()
        const loading = useLoading()
        const proxy = getCurrentInstance().proxy
        let verifyArray = []
        const  reflect = {
            "2": "basic",
            "3": "work",
            "4": "contact",
            "8": "kycAadhaarAndPan",
            "9": "kycFaceAndHold"
        }
        const r2 = {
            "basic":"basic",
            "work":"work",
            "contact":"contacts",
            "kycAadhaarAndPan":"identity",
            "kycFaceAndHold":"face",
        }
        const tem = [2,3,8,9,4]
        const route = router.currentRoute
        onMounted( async ()=> {
            const loader = loading.show({
                container: null
            })
            const data = await getAuthInfo()
            if(data.code == 0){
                verifyArray = data.data.userAuthConfigVoList
                loader.hide()
                let compelete = true
                console.log(123)
                for(let i = 0; i< verifyArray.length;i++){
                    let target = verifyArray[i]
                    console.log(1)
                    for(let y=0; y<target['pageTypes'].length;y++) {
                        const finalTarget = target['pageTypes'][y]
                        let rl = reflect[finalTarget]                                                
                        if(data.data[rl] == 0) {
                            if(finalTarget == 4) {
                                let fraud = await fraudCheck()
                                if(fraud.code == 0) {
                                    if(fraud.data.canApply == 0) {
                                        router.push({
                                            "path":'/'                                            
                                        })
                                    } else {
                                        router.push({
                                            "path":'/download',
                                            query:{
                                                state:0
                                            }
                                        })
                                    }
                                }
                                
                                compelete = false
                                break   
                            } else {
                                router.push({
                                    "path":`/auth/${r2[rl]}`,
                                    "query":{
                                        "pid": route.value.query.pid,
                                        "step": tem.indexOf(finalTarget) + 1,
                                        "as": tem.length 
                                    }
                                })
                                compelete = false
                                break    
                            }
                            
                        }
                    }
                    if(!compelete){
                        break
                    }
                                        
                }
                if(compelete) {
                    getOrders().then((resp)=>{
                        loader.hide()
                        const list = resp.data.filter((element)=>{
                            return (route.value.query.pid == element.productId) && (element.orderState == '1' || element.orderState == '2' || element.orderState == '4' || element.orderState == '6' || element.orderState == '8')
                        })
                        if(list.length > 0) {
                            router.push({
                                path:'/orders'
                            })
                        } else {
                            router.replace({
                                "path":`/product/${route.value.query.pid}/detail`
                            })
                        }
                    })
                    
                }
            } else {
                loader.hide()
                proxy.$toast.show(data.msg)
            }
            
        })
    }
}
</script>